const modalConstants = {
  OPEN_MODAL: 'OPEN_MODAL',
  CLOSE_MODAL: 'CLOSE_MODAL',
  RESET_SUCCESS_RECOVERY_TEXT: 'RESET_SUCCESS_RECOVERY_TEXT',
};

export default modalConstants;
